export default "__VITE_ASSET__BFS0VIUy__"